import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reporteCostoInventario';
import ReporteCostoInventario from './ReporteCostoInventario';

const mstp = state => {
    return {
        ...state.reporteCostoInventario,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(ReporteCostoInventario)
